// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.content_Ny_lF {
  display : flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding : var( --size-padLarge, 16px ) var( --size-padXLarge, 32px );
}

.content_Ny_lF > * {
  margin-top: var( --size-padMedium, 8px );
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/views/LoadingView.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oEAAoE;AACtE;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["\n.content {\n  display : flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding : var( --size-padLarge, 16px ) var( --size-padXLarge, 32px );\n}\n\n.content > * {\n  margin-top: var( --size-padMedium, 8px );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_Ny_lF`
};
export default ___CSS_LOADER_EXPORT___;
